import { Component , HostBinding, OnInit} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import * as $ from 'jquery';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { UserAuthService } from '../services/user-auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UpdateProfileService } from '../services/update-profile.service';
import { Enum } from '../helpers/enums/enum';
import { MessageService } from '../services/message.service';
import { Subscription } from 'rxjs';
import { NgIf } from '@angular/common';
import { Guid } from 'guid-typescript';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Idle } from '@ng-idle/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  imports: [
    RouterLink,
    NgIf
]
})
export class HeaderComponent implements OnInit {

  @HostBinding('style.width') public readonly WIDTH = '100%';
  userData = null;
  title = 'webapp';
  hideBanckAccountsPage: boolean = false;
  messages: any[] = [];
  subscription: Subscription;

  constructor(
    public readonly router: Router,
    private readonly cookieService: CookieService,
    private readonly userAuthService: UserAuthService,
    private readonly oauthService: OAuthService,
    private readonly spinner: NgxSpinnerService,
    private readonly updateProfileService: UpdateProfileService,
    private readonly messageService: MessageService,
    private readonly modalService: NgbModal,
    private readonly idle: Idle
  ) {
    this.updateProfileService.getClickEvent().subscribe(()=>{
      this.userData = this.userAuthService.getIdentityClaims();
      });

      this.subscription = this.messageService.getMessage().subscribe({
        next: (message) => {
          if (message) {
            this.messages.push(message);
           this.checkBranchUserOnLogin(message);
          } else {
            this.messages = [];
          }
        },
        error: () => {}
      });
  }

  ngOnInit(): void {
    this.userData = this.userAuthService.getIdentityClaims();
    this.bindNavBar();
    this.toogleStitchProfileMenu();
    this.checkBranchUserOnLoad();
  }



  checkBranchUserOnLogin(message){
    if(message === Enum.BranchUserLoginType.FirstLogin.toString())
    {
      this.hideBanckAccountsPage = true;
    }
  }

  checkBranchUserOnLoad(){
    let isFirstLoginForBranchUser = sessionStorage.getItem('branchUserLogin');
    console.log("isFirstLoginForBranchUser ", isFirstLoginForBranchUser)
    if(JSON.parse(isFirstLoginForBranchUser) == Enum.BranchUserLoginType.FirstLogin){
      this.hideBanckAccountsPage = true;
    }
  }

  toogleStitchProfileMenu() {
    const fn = () => {
      const isStitchEnabled = localStorage.getItem('isStitchEnabled');
      if (isStitchEnabled && JSON.parse(isStitchEnabled)) {
        $('#liStitchAccounts').show();
      } else {
        $('#liStitchAccounts').hide();
      }
    };

    setInterval(() => {
      fn();
    }, 2000);

    fn();
  }

  bindNavBar() {
    const hamburger = $('.navbar-toggler');
    const navBar = $('.navbar');
    const backDrop = '<div class="backdrop bg-transparent"></div>';
    // tslint:disable-next-line: only-arrow-functions
    hamburger.off().on('click', function () {
      navBar.addClass('push-menu-visible');
      navBarRight.removeClass('push-menu-visible');
      $('body').addClass('push-menu-body');
      $(backDrop).appendTo('body').on('click', function () {
        navBar.removeClass('push-menu-visible');
        $(this).remove();
        $('body').removeClass('push-menu-body');
      });
    });

    const hamburgerRight = $('.navbar-togglerRight');
    const navBarRight = $('.navbarRight');
    const backDropRight = '<div class="backdrop bg-transparent"></div>';
    hamburgerRight.off().on('click', function () {
      navBarRight.addClass('push-menu-visible');
      navBar.removeClass('push-menu-visible');
      $('body').addClass('push-menu-body');
      $(backDropRight).appendTo('body').on('click', function () {
        navBarRight.removeClass('push-menu-visible');
        $(this).remove();
        $('body').removeClass('push-menu-body');
      });
    });

    const navbarClose = $('.navbar');
    if (navbarClose.length > 0) {
      // tslint:disable-next-line: only-arrow-functions
      navbarClose.off().on('click', function() {
        navBar.removeClass('push-menu-visible');
        $('body').removeClass('push-menu-body');
        $('.backdrop').remove();
      });
    }
    const navbarCloseRight = $('.navbarRight');
    if (navbarCloseRight.length > 0) {
      // tslint:disable-next-line: only-arrow-functions
      navbarCloseRight.off().on('click', function() {
        navBarRight.removeClass('push-menu-visible');
        $('body').removeClass('push-menu-body');
        $('.backdrop').remove();
      });
    }
  }

  logout() {
    this.modalService.dismissAll();
    this.idle.stop();
    this.spinner.show();
    setTimeout(() => {
    (window as any).fcWidget.destroy();
    this.cookieService.delete('submissionId', '/');
    this.cookieService.delete('userId', '/');
    localStorage.removeItem('isLoginSuccess');
    localStorage.removeItem("totalCurrentBalance");
    localStorage.removeItem("creditHistoryId");
    localStorage.removeItem("lastUpdateDate");
    sessionStorage.removeItem('loadCreditHistory');
    sessionStorage.removeItem('loadCreditHealthInfo');
    sessionStorage.removeItem('isProfileDcQuoteCall');
    this.cookieService.delete('isBranchUserComing','/');

    sessionStorage.removeItem('branchUTMParams');
    sessionStorage.removeItem('IsAssociatedWithBranch');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('userPhoneNumber');
    sessionStorage.removeItem('lastPublicRoute');
    this.userAuthService.logOut();
    this.spinner.hide();
    }, 1000);

  }

  azureAdlogin() {
    let submissionId = '';
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }
    const submissionCode = Guid.create().toString();
    this.oauthService.initLoginFlow('', { submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
      instrumentationKey: environment.appInsights.instrumentationKey });
  }

  navigateToRegister() {
    const lastPublicRoute = sessionStorage.getItem('lastPublicRoute') || '';
    const normalizedLastPublicRoute = lastPublicRoute.toLowerCase();

    if (normalizedLastPublicRoute.startsWith('/hl-registration')) {
      this.router.navigateByUrl(lastPublicRoute);
      return;
    }

    this.router.navigateByUrl('/register');
  }


}

